import client from "./client";

const base = (branchId) => `/branches/${branchId}/qr-zones`;

export const fetchQrZones = async (branchId) => (await client.get(base(branchId))).data;
export const createQrZone = async (branchId, body) => (await client.post(base(branchId), body)).data;
export const updateQrZone = async (branchId, zoneId, body) =>
  (await client.put(`${base(branchId)}/${zoneId}`, body)).data;
export const rotateQrZone = async (branchId, zoneId) =>
  (await client.post(`${base(branchId)}/${zoneId}/rotate`)).data;
export const deleteQrZone = async (branchId, zoneId) => (await client.delete(`${base(branchId)}/${zoneId}`)).data;
